export default "__VITE_ASSET__I9LYV81S__"